import { useApi } from '../useApi';
import { useEffect } from 'react';
import { useProfileContext } from '../../contexts/ProfileProvider';

export const useVerify = () => {
  const { refetch } = useProfileContext();
  const { data, error, loading, sendRequest } = useApi();

  useEffect(() => {
    if (data && !error) {
      refetch();
    }
  }, [data, error, refetch]);

  const verify = (token: string) => {
    sendRequest({
      url: `/authenticate/verify/${token}`,
    });
  };

  return { data, error, loading, verify };
};
